import { useEffect } from 'react';
import { getProfile } from '../../api/apiHandler';

function GoogleTranslateLoader() {

  const getSchoolProfile = () => {
    const donor_id = localStorage.getItem("DAid"); 
    getProfile({donor_id}).then((res) => {
      if (res.data.code === "1") {
        const lang = res.data.data.language;
        setTimeout(() => selectDefaultLanguage(lang), 500);
      }
    });     
  }

  const initGoogleTranslate = () => {
    if (window.google && window.google.translate) {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          layout: window.google.translate.TranslateElement.InlineLayout.VERTICAL,
          autoDisplay: false,
        },
        'google_translate_element'
      );
    } else {
      setTimeout(initGoogleTranslate, 100);
    }
  };
  
  useEffect(() => {    
    // Attach global callback AFTER it's defined
    window.googleTranslateElementInit = initGoogleTranslate;
    addScript();
    getSchoolProfile()
    setTimeout(removePoweredBy, 500);  
  }, []);

  const selectDefaultLanguage = (lang) =>{
      const select = document.querySelector('#google_translate_element select.goog-te-combo');
      if (select && select.options.length > 1) {
        select.value = lang;

        // Create and dispatch a real 'change' event
        const event = document.createEvent("HTMLEvents");
        event.initEvent("change", true, true);
        select.dispatchEvent(event);

      }
  }

  const addScript = () => {
    if (!document.getElementById('google-translate-script')) {
      const script = document.createElement('script');
      script.id = 'google-translate-script';
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
    }
  };

  const removePoweredBy = () => {
    const gadget = document.querySelector('.goog-te-gadget');
    if (gadget) {
      // Remove all child nodes that are not <select>
      [...gadget.childNodes].forEach(node => {
        if (
          node.nodeType === Node.TEXT_NODE ||         // "Powered by" text
          (node.nodeType === Node.ELEMENT_NODE &&     // Link or image
          node.tagName !== 'DIV' &&
          !node.classList.contains('goog-te-combo'))
        ) {
          gadget.removeChild(node);
        }
      });
    }
  };

  return <div id="google_translate_element" />;
}

export default GoogleTranslateLoader;